/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../apiHelpers/SlotAPIHelper'
], (SlotAPIHelper) => {
	class APISpec {
		getAPISpec() {
			if (!this.apiSpec) {
				this.apiSpec = {
					name: 'slot API',
					features: {
						'Dashboard.Transaction': this.transaction
					},
					events:{
						propagationInfo: {
							info: {
								refresh: {
									dataIfQueryChanged: true,
									// although the query may have not changed, additional setData 
									// is necessary to reflect the new slot mapping to the data
									setData: true
								},
								slotId: this.getId()
							},
							callStack: {
								name: 'getSlot',
								params: [this.getId()]
							}
						},
						actions: {
							'removeDataItemsMapping': {
								eventName: 'dataitems:removeMapping',
								onBeforeAction: () => {
									return {
										previousState: {
											isMultiMeasuresSeriesSlot: SlotAPIHelper.isMultiMeasuresSeriesSlot(this),
											isMultiMeasuresValueSlot: SlotAPIHelper.isMultiMeasuresValueSlot(this)
										}
									};
								},
								getInfo: (args, dataItems, { options: { previousState } }) => {
									let refresh = {
										setData: true
									};
									// 1. any removal on multiple measures value slot requires a new query
									// 2. any removal on multiple measures series slot may not require a new query
									//   or at least requires a post-proceesing to be performed.
									if (previousState.isMultiMeasuresValueSlot ||
										(previousState.isMultiMeasuresSeriesSlot && this.getDataItemList().length)) {
										refresh['data'] = true;
									} else {
										refresh['dataIfQueryChanged'] = true;
									}
									return {
										refresh,
										dataItemIdList: args[0]
									};
								},
								getUndoActions: (args) => {
									const undoActions = [];
									const ids = args[0];
									if (ids){
										let lastIndex;
										ids.forEach(id => {
											const dataItem = this.getDataItem(id);
											if (dataItem){
												const currentIndex = this.getDataItemIndex(id);
												// add an addColumn reverse action
												if (currentIndex !== lastIndex + 1){
													undoActions.push({
														name: 'addDataItemsMapping',
														params: [[], currentIndex]
													});
												}
												const lastAction = undoActions[undoActions.length -1];
												// add the column id to column ids param
												lastAction.params[0].push(dataItem.getId());
												lastIndex = currentIndex;
											}
										});
									}
									return undoActions;
								}
							},
							'addDataItemsMapping': {
								eventName: 'dataitems:addMapping',
								isResolvePostResponse: true,
								getInfo: (args) => {
									const isMultiMeasuresSeriesSlot = SlotAPIHelper.isMultiMeasuresSeriesSlot(this) && args[0].length > 1;
									const isMultiMeasuresValueSlot = SlotAPIHelper.isMultiMeasuresValueSlot(this);
									let refresh = {
										setData: true
									};
									// 1. Any addition to the multiple measure value slot requires a new query
									// 2. Any addition to the multiple measure series slot which results a nesting
									//    requires at least the post processing to be performed
									if (isMultiMeasuresSeriesSlot || isMultiMeasuresValueSlot) {
										refresh['data'] = true;
									} else {
										refresh['dataIfQueryChanged'] = true;
									}
									return {
										refresh,
										dataItemIdList: args[0],
										position: args[1] || 0
									};
								},
								getUndoActions: (args) => {
									return [{
										name: 'removeDataItemsMapping',
										params:[args[0]]
									}];
								}
							}
						}
					}
				};
			}
			return this.apiSpec;
		}
	}

	return APISpec;
});
